// @general-version
import Vue from 'vue';
import VueI18n from "vue-i18n";
import en from 'view-design/dist/locale/en-US';
import zh from 'view-design/dist/locale/zh-CN';
import ko from 'view-design/dist/locale/ko-KR';

import i18nModule from "./i18nModule.js";
Vue.use(VueI18n);

let lang = localStorage.getItem("lang") || "zh-CN";

Vue.config.lang = lang;
export const i18n = new VueI18n({
  locale: lang, // 语言标识
  messages: {
    // 中文语言包
    'zh-CN': {
      ...i18nModule["zh-CN"],
      ...zh
    },
    // 英文语言包
    'en-US': {
      ...i18nModule["en-US"],
      ...en
    },
    // 韩语语言包
    'ko-KR': {
      ...i18nModule["ko-KR"],
      ...ko
    },
  },
  silentTranslationWarn: true
});
